module.exports = __webpack_public_path__ + "img/solution-tool-system-pic-1.7c08f161.png";